import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from 'antd';

type PropsType = {
  onClickMenuDelete: () => void;
  onClickMenuEdit?: () => void;
  isCardUnremovable?: boolean;
};

export const useDropdownMenu = ({ onClickMenuDelete, onClickMenuEdit, isCardUnremovable }: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });

  return (
    <Menu
      items={[
        {
          key: '1',
          onClick: onClickMenuEdit,
          label: t('edit'),
        },
        isCardUnremovable
          ? null
          : {
              key: '2',
              danger: true,
              onClick: onClickMenuDelete,
              label: t('delete'),
            },
      ]}
    />
  );
};
